import { Link } from "react-router-dom";
import { useState } from "react";

import storyImage from "../assets/IMG_7216.jpg";
import templeOverlay from "../assets/temple-overlay.png";

import { palette, fonts } from "./theme";
import Sidebar from "../components/Sidebar";

import Hero from "./Image";
import Carousel from "./Carousel";

// STATIC HOURS
const HOURS = {
  weekday: "11 AM – 9:30 PM",
  weekend_breakfast: "9:00 AM – 11:00 AM",
  weekend_timing: "11:00 AM – 10:30 PM",
};

export default function Home() {
  const [story, setStory] = useState("");

  return (
    <div
      className="relative min-h-screen w-full"
      style={{ fontFamily: fonts.body }}
    >
      {/* BACKGROUND OVERLAY */}
      <div
        className="absolute inset-0"
        style={{
          backgroundColor: palette.bg,
          backgroundImage: `url(${templeOverlay})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          opacity: 0.18,
          mixBlendMode: "overlay",
          zIndex: 0,
        }}
      />

      {/* MAIN LAYOUT */}
      <div
        className="relative z-10 min-h-screen md:flex"
        style={{ color: palette.ink }}
      >
        {/* DESKTOP SIDEBAR */}
        <div
          className="
            hidden md:flex 
            md:flex-col md:justify-between 
            md:w-[350px] 
            md:bg-[#C0A87B] 
            md:border-r 
            md:p-8
          "
          style={{ borderColor: palette.railLine }}
        >
          <Sidebar hours={HOURS} />
        </div>

        {/* MAIN CONTENT */}
        <div className="flex-1">

          {/* MOBILE HEADER */}
          <header
            className="sticky top-0 z-75 border-b md:hidden"
            style={{
              backgroundColor: `${palette.bg}E6`,
              backdropFilter: "blur(8px)",
              borderColor: palette.railLine,
            }}
          >
            <div className="mx-auto max-w-7xl px-4 py-3 flex items-center justify-between">
              <nav className="flex items-center gap-4 text-xs">
                <Link to="/" className="hover:underline">Home</Link>
                <Link to="/menu" className="hover:underline">Menu</Link>
                <Link to="/about" className="hover:underline">About</Link>
		<Link to="/tiffin" className="hover:underline">Tiffin</Link>
		<Link to="/catering" className="hover:underline">Catering</Link>
                <Link to="/gallery" className="hover:underline">Gallery</Link>
                <Link to="/contact" className="hover:underline">Contact</Link>
              </nav>
            </div>
          </header>

          {/* HERO */}
          <Hero />

          {/* DIVIDER */}
          <div className="w-full flex items-center justify-center my-6">
            <div
              className="relative flex items-center justify-center w-full"
              style={{
                height: "28px",
                background: "#6A1F26",
                borderTop: `2px solid ${palette.gold}`,
                borderBottom: `2px solid ${palette.gold}`,
              }}
            >
              <div style={{ height: "2px", backgroundColor: palette.gold, width: "32%" }} />
              <div style={{ height: "2px", backgroundColor: palette.gold, width: "32%" }} />
            </div>
          </div>

          {/* AWARDS */}
          <section
            className="border-y"
            style={{ borderColor: palette.railLine, backgroundColor: "#FFFFFF" }}
          >
            <div className="mx-auto max-w-7xl px-6 py-6 grid grid-cols-1 md:grid-cols-3 gap-6 text-center text-sm">
              <div>
                <div className="font-bold">Quality</div>
                <div style={{ color: palette.sub }}>Great food at a great value</div>
              </div>
              <div>
                <div className="font-bold">Reservation Friendly</div>
                <div style={{ color: palette.sub }}>Plan ahead for peak hours</div>
              </div>
              <div>
                <div className="font-bold">Pure Vegetarian</div>
                <div style={{ color: palette.sub }}>Authentic South Indian flavours</div>
              </div>
            </div>
          </section>

          {/* STORY SECTION */}
          <section className="py-14">
            <div className="mx-auto max-w-7xl px-6 grid md:grid-cols-2 gap-8 items-center">

              <div
                className="rounded-2xl h-64 md:h-80 bg-center bg-cover"
                style={{
                  backgroundImage: `url(${storyImage})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                }}
              />

              <div>
                <h2
                  className="text-2xl md:text-3xl font-extrabold uppercase"
                  style={{ fontFamily: fonts.heading }}
                >
                  Our Story
                </h2>
                <p className="mt-3 leading-relaxed" style={{ color: palette.sub }}>
                  {story}
                </p>
                <div className="mt-5">
                  <Link to="/about" className="underline font-semibold">
                    Learn more
                  </Link>
                </div>
              </div>

            </div>
          </section>

          {/* SIGNATURE ITEMS */}
          <section className="py-12" style={{ backgroundColor: palette.blush }}>
            <div className="mx-auto max-w-7xl px-6">

              <h3
                className="text-center mb-8 uppercase"
                style={{
                  fontFamily: fonts.heading,
                  color: palette.ink,
                  fontWeight: 800,
                  fontSize: 28,
                }}
              >
                Signature Dosas & More
              </h3>

              <div className="grid md:grid-cols-3 gap-8">

                {[
                  { name: "Masala Dosa", desc: "Crispy dosa filled with seasoned potatoes", price: "$12" },
                  { name: "Onion Rava Dosa", desc: "Paper-thin semolina dosa", price: "$12" },
                  { name: "Mini Idli in Sambar", desc: "Soft idlis in hot sambar", price: "$10" },
                  { name: "Filter Coffee", desc: "Traditional davara set", price: "$4" },
                  { name: "South Indian Thali", desc: "Complete meal served with dessert", price: "$18" },
                  { name: "Mysore Bonda", desc: "Crispy urad dal dumplings", price: "$9" },
                ].map((item) => (
                  <div
                    key={item.name}
                    className="rounded-2xl bg-white shadow p-5 flex flex-col justify-between"
                    style={{ border: `1px solid ${palette.railLine}` }}
                  >
                    <div>
                      <div className="font-semibold text-lg">{item.name}</div>
                      <div className="mt-2 text-sm" style={{ color: palette.sub }}>
                        {item.desc}
                      </div>
                    </div>
                    <div className="mt-4 text-sm font-bold" style={{ color: palette.gold }}>
                      {item.price}
                    </div>
                  </div>
                ))}

              </div>

            </div>
          </section>

          {/* TESTIMONIALS */}
          <section className="py-14">
            <div className="mx-auto max-w-7xl px-6">
              <h3
                className="text-center mb-8 uppercase"
                style={{
                  fontFamily: fonts.heading,
                  color: palette.ink,
                  fontWeight: 800,
                  fontSize: 24,
                }}
              >
                Guests Say…
              </h3>

              <Carousel
                items={[
                  { quote: "Amazing food! Fresh and authentic.", author: "Nilesh Jaiswal" },
                  { quote: "Best South Indian food in Oakville.", author: "Radhey Shah" },
                  { quote: "Loved the ambience and flavours.", author: "Pru P" },
                ]}
                interval={5000}
              />
            </div>
          </section>

          {/* FOOTER */}
          <footer className="py-6 text-center text-sm" style={{ color: palette.sub }}>
            18% gratuity applies for parties of 6 or more. Please inform us of any allergies.
          </footer>

          {/* MOBILE SIDEBAR */}
          <div
            className="block md:hidden w-full mt-8"
            style={{
              backgroundColor: "#C0A87B",
              padding: "24px 20px",
              borderTop: `1px solid ${palette.railLine}`,
            }}
          >
            <Sidebar hours={HOURS} />
          </div>

        </div>
      </div>
    </div>
  );
}
